import React, { useState,useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { endpoints } from "../../services/apiurl";
import Input from "../UI/Input/Input";
import TextAreaInput from "../UI/Input/TextAreaInput";
import Card from "@mui/material/Card";
import FileUploader from "../FileUploader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddBrands = () => {
  const [rest, setRest] = useState([]);
  let history = useHistory();
  const [cat, setCat] = useState({
    name: "",

    address: "",
    sort: "",

    description: "",
    instagram_url: "",
    facebook_url: "",
    twitter_url: "",
    people_served: "",
    events_hosted: "",
    opened_in: "",

    title1: "",
    title2: "",
    title3: "",
    title4: "",
    subtitle1: "",
    subtitle2: "",
    subtitle3: "",
    subtitle4: "",
    restro_id: "",
    status: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileImage, setSelectedFileImage] = useState(null);
  const [selectedwebImage, setSelectedwebImage] = useState(null);
  const [selectedwebVideo, setSelectedwebVideo] = useState(null);
  const [selectedfeaturesicon1, setSelectedfeaturesicon1] = useState(null);
  const [selectedfeaturesicon2, setSelectedfeaturesicon2] = useState(null);
  const [selectedfeaturesicon3, setSelectedfeaturesicon3] = useState(null);
  const [selectedfeaturesicon4, setSelectedfeaturesicon4] = useState(null);

  const [loading, setloading] = useState(false);

  const {
    name,
    description,
    instagram_url,
    sort,
    opened_in,
    people_served,
    events_hosted,
    facebook_url,
    twitter_url,
    website_url,
    title1,
    title2,
    title3,
    title4,
    subtitle1,
    subtitle2,
    subtitle3,
    subtitle4,
    address,
    status,
    restro_id,
  } = cat;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
    console.log(cat);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      alert("Please select logo image");
      return false;
    }
    if (!selectedFileImage) {
      alert("Please select inner image");
      return false;
    }
    setloading(true);

    const formData = new FormData();
    formData.append("name", name);

    formData.append("address", address);
    formData.append("sort", sort);

    formData.append("opened_in", opened_in);
    formData.append("people_served", people_served);
    formData.append("events_hosted", events_hosted);

    formData.append("description", description);
    formData.append("instagram_url", instagram_url);
    formData.append("facebook_url", facebook_url);
    formData.append("twitter_url", twitter_url);
    formData.append("title1", title1);
    formData.append("title2", title2);
    formData.append("title3", title3);
    formData.append("title4", title4);
    formData.append("subtitle1", subtitle1);
    formData.append("subtitle2", subtitle2);
    formData.append("subtitle3", subtitle3);
    formData.append("subtitle4", subtitle4);
    formData.append("restro_id", restro_id);


    formData.append("logo", selectedFile);
    formData.append("image", selectedFileImage);

    formData.append("banner_image", selectedwebImage);
    formData.append("banner_video", selectedwebVideo);
    formData.append("featuresicon1", selectedfeaturesicon1);
    formData.append("featuresicon2", selectedfeaturesicon2);
    formData.append("featuresicon3", selectedfeaturesicon3);
    formData.append("featuresicon4", selectedfeaturesicon4);

    formData.append("website_url", website_url);

    formData.append("status", status);

    try {
      const response = await axios.post(endpoints.addBrands, formData);
      setloading(false);
      history.goBack();
      if (response.data && response.data.status === true) {
        toast.success("Brand Added Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        // Handle other cases if needed
      }
    } catch (error) {
      console.error("Error during editing Brand:", error);
      setloading(false);

      toast.error("Error during editing Brand. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    getRestaurentsDropDown()
}, []);


const getRestaurentsDropDown = async () => {
    await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
        setRest(response.data.data);
        //console.log(setRest)
    });
};

  return (
    <div className="ui main">
      <h2>Add Brand</h2>
      <Card className="px-3 py-3">
    
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              onChange={(e) => onInputChange(e)}
             requiredInput="required"
              value={name}
              class="col col-6"
            />
<div className="col-6">
<label>Select Restaurent</label>
                            <select name="restro_id" required className="form-control" onChange={e => onInputChange(e)} >
                                <option value="">Select Restaurents</option>
                                {rest.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.name}</option>
                                })}
                            </select>
</div>



          </div>

          <div className="row">
            <Input
              id="facebook_url"
              label="Facebook Url"
              type="text"
              name="facebook_url"
              place="Facebook Url"
              onChange={(e) => onInputChange(e)}
             
              value={facebook_url}
              class="col col-6"
            />

            {/* <Input
              id="twitter_url"
              label="twitter_url"
              type="text"
              name="twitter_url"
              place="twitter_url"
              onChange={(e) => onInputChange(e)}
             
              value={twitter_url}
              class="col col-6"
            /> */}
            
            <Input
              id="instagram_url"
              label="Instagram Url"
              type="text"
              name="instagram_url"
              place="Instagram Url"
              onChange={(e) => onInputChange(e)}
              
              value={instagram_url}
              class="col col-6"
            />
          </div>

          <div className="row">
            <Input
              id="website_url"
              label="Website Url"
              type="text"
              name="website_url"
              place="Website Url"
              onChange={(e) => onInputChange(e)}
             
              value={website_url}
              class="col col-6"
            />

            <div className="col col-4">
              <label>Status</label>
              <select
                name="status"
               requiredInput="required"
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>
            <Input
              id="sort"
              label="Sort No."
              type="text"
              name="sort"
              place="Sort No."
              onChange={(e) => onInputChange(e)}
              value={sort}
              class="col col-2"
            />
          </div>
          <div className="row py-3">
            <Input
              id="people_served"
              label="People Served"
              type="text"
              name="people_served"
              place="People Served"
              onChange={(e) => onInputChange(e)}
             
              value={people_served}
              class="col col-4"
            />
            <Input
              id="events_hosted"
              label="Events Hosted"
              type="text"
              name="events_hosted"
              place="Events Hosted"
              onChange={(e) => onInputChange(e)}
           
              value={events_hosted}
              class="col col-4"
            />
            <Input
              id="opened_in"
              label="Opened In"
              type="text"
              name="opened_in"
              place="Opened In"
              onChange={(e) => onInputChange(e)}
              value={opened_in}
              class="col col-4"
            />
          </div>
          <div className="row py-2">
            <Input
              id="title1"
              label="Title1"
              type="text"
              name="title1"
              place="Title1"
              onChange={(e) => onInputChange(e)}
             
              value={title1}
              class="col col-3"
            />

            <Input
              id="title2"
              label="Title2"
              type="text"
              name="title2"
              place="Title2"
              onChange={(e) => onInputChange(e)}
              value={title2}
              class="col col-3"
            />
            <Input
              id="title3"
              label="Title3"
              type="text"
              name="title3"
              place="Title3"
              onChange={(e) => onInputChange(e)}
              value={title3}
              class="col col-3"
            />
            <Input
              id="title4"
              label="Title4"
              type="text"
              name="title4"
              place="Title4"
              onChange={(e) => onInputChange(e)}
              value={title4}
              class="col col-3"
            />
          </div>
          <div className="row py-2">
            <Input
              id="subtitle1"
              label="Sub_Title1"
              type="text"
              name="subtitle1"
              place="Sub_Title1"
              onChange={(e) => onInputChange(e)}
            
              value={subtitle1}
              class="col col-3"
            />
            <Input
              id="subtitle2"
              label="Sub_Title2"
              type="text"
              name="subtitle2"
              place="Sub_Title2"
              onChange={(e) => onInputChange(e)}
            
              value={subtitle2}
              class="col col-3"
            />
            <Input
              id="subtitle3"
              label="Sub_Title3"
              type="text"
              name="subtitle3"
              place="Sub_Title3"
              onChange={(e) => onInputChange(e)}
            
              value={subtitle3}
              class="col col-3"
            />
            <Input
              id="subtitle4"
              label="Sub_Title4"
              type="text"
              name="subtitle4"
              place="Sub_Title4"
              onChange={(e) => onInputChange(e)}
            
              value={subtitle4}
              class="col col-3"
            />
          </div>
          <div className="row">
            <TextAreaInput
              id="description"
              label="Description"
              name="description"
              place="Description"
              onChange={(e) => onInputChange(e)}
            
              value={description}
              class="col col-6"
            />
            <TextAreaInput
              id="address"
              label="Address"
              name="address"
              place="Address"
              onChange={(e) => onInputChange(e)}
            
              value={address}
              class="col col-6"
            />
          </div>
          <div className="row py-4">
            <div className="col col-3">
              <label>FeaturesIcon1</label>
              <p>
                Note: Icon Size Should be <b>84px x 84px </b>
              </p>

              <FileUploader
                onFileSelectSuccess={(file) => setSelectedfeaturesicon1(file)}
                onFileSelectError={({ error }) => alert(error)}
              />
            </div>
            <div className="col col-3">
              <label>FeaturesIcon2</label>
              <p>
                Note: Icon Size Should be <b>84px x 84px </b>
              </p>

              <FileUploader
                onFileSelectSuccess={(file) => setSelectedfeaturesicon2(file)}
                onFileSelectError={({ error }) => alert(error)}
              />
            </div>
            <div className="col col-3">
              <label>FeaturesIcon3</label>
              <p>
                Note: Icon Size Should be <b>84px x 84px </b>
              </p>

              <FileUploader
                onFileSelectSuccess={(file) => setSelectedfeaturesicon3(file)}
                onFileSelectError={({ error }) => alert(error)}
              />
            </div>
            <div className="col col-3">
              <label>FeaturesIcon4</label>
              <p>
                Note: Icon Size Should be <b>84px x 84px </b>
              </p>

              <FileUploader
                onFileSelectSuccess={(file) => setSelectedfeaturesicon4(file)}
                onFileSelectError={({ error }) => alert(error)}
              />
            </div>
          </div>

          <div className="row py-4">
            <div className="col col-4">
              <label>Logo (For Web)</label>
              <p>
                Note: Image Size Should be <b>268 x 70px </b>
              </p>

              <FileUploader
                onFileSelectSuccess={(file) => setSelectedFile(file)}
                onFileSelectError={({ error }) => alert(error)}
              />
            </div>
            <div className="col col-4">
              <label>Home Image (For Web) </label>
              <p>
                Note: Image Size Should be <b>513 x 418px </b>
              </p>
              <FileUploader
                onFileSelectSuccess={(file) => setSelectedFileImage(file)}
                onFileSelectError={({ error }) => alert(error)}
              />
            </div>
            <div className="col col-4">
              <label>Banner Video (For Web)</label>
              <p>
                Note: Video Size Should be <b> 40mb</b>
              </p>

              <FileUploader
                onFileSelectSuccess={(file) => setSelectedwebVideo(file)}
                onFileSelectError={({ error }) => alert(error)}
              />
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                {/* <Button type="submit" variant="contained" size="medium">
                                    Save
                                </Button> */}
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
                <ToastContainer />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddBrands;
